import { Engine } from '../../domain/model/engine';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface DeleteEngineRepository {
    (id: number): Promise<Engine>
}

const deleteEngineRepository = (axios: AxiosInstance): DeleteEngineRepository => async (id: number) => {
    try {

        const response: AxiosResponse = await axios.delete(`/engine/${id}`)
        const engine: Engine = response.data
        return engine
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deleteEngineRepository